interface ComponentProps {
  text: string;
  status: 'active' | 'inactive' | string;
}

export const BadgeIndicator: React.FC<ComponentProps> = ({ text, status }) => {
  const determineStatus = (text: string, status: string) => {
    switch (status) {
      case 'active':
        return (
          <span className="inline-flex items-center bg-green-100 text-green-800 text-xs font-medium px-2.5 py-2 rounded-md">
            <span className="w-2 h-2 me-1 bg-green-500 rounded-md"></span>
            <span className="first-letter:capitalize">
              {text.toLowerCase()}
            </span>
          </span>
        );
      case 'inactive':
        return (
          <span className="inline-flex items-center bg-orange-100 text-orange-800 text-xs font-medium px-2.5 py-2 rounded-md">
            <span className="w-2 h-2 me-1 bg-orange-500 rounded-md"></span>
            <span className="first-letter:capitalize">
              {text.toLowerCase()}
            </span>
          </span>
        );

      default:
        return <>{text}</>;
    }
  };

  return <div>{determineStatus(text, status)}</div>;
};
